import { axiosInstance } from './api';

/** План продаж (Алексей 22.10, #1941/#1942) — BE plugins/ops_tasks/api/sales_plan.py. */
export type SalesPlanKind = 'offer' | 'reminder' | 'target';

export interface SalesPlanItemDto {
  id?: number;
  kind: SalesPlanKind;
  title: string;
  time_from: string | null; // "HH:MM[:SS]"
  time_to: string | null;
  weekdays_mask: number; // бит 0 = пн
  on_date: string | null; // YYYY-MM-DD — только в этот день
  target_qty: number | null;
  order?: number;
}

export interface SalesPlanTodayRow {
  id: number;
  kind: SalesPlanKind;
  title: string;
  window: string;
  time_from: string | null;
  time_to: string | null;
  active: boolean;
  target_qty: number | null;
  sold: number | null;
}

export interface SalesPlanTodayDto {
  date: string;
  now: string;
  has_receipts: boolean;
  configured: boolean;
  offers_now: SalesPlanTodayRow[];
  offers_later: SalesPlanTodayRow[];
  reminders: SalesPlanTodayRow[];
  targets: SalesPlanTodayRow[];
}

export const salesPlanKey = (zoneId: string) => ['sales-plan', zoneId] as const;

export const getSalesPlan = (zoneId: string) =>
  axiosInstance.get<{ items: SalesPlanItemDto[]; show_on_dashboard: boolean }>(`/ops_tasks/sales-plan/${zoneId}/`);

/** Тоггл «выводить на дашборд смены» (Алексей 27.10 #2962). */
export const setSalesPlanOnDashboard = (zoneId: string, on: boolean) =>
  axiosInstance.patch<{ show_on_dashboard: boolean }>(`/ops_tasks/sales-plan/${zoneId}/`, { show_on_dashboard: on });

export const putSalesPlan = (zoneId: string, items: SalesPlanItemDto[]) =>
  axiosInstance.put<{ items: SalesPlanItemDto[]; show_on_dashboard: boolean }>(`/ops_tasks/sales-plan/${zoneId}/`, { items });

export const getSalesPlanToday = (zoneId: string) =>
  axiosInstance.get<SalesPlanTodayDto>(`/ops_tasks/sales-plan/${zoneId}/today/`);

/** Google-таблица плана (#3191) — BE sales-plan/<zone>/sheet/. */
export interface SalesPlanSheetDto {
  sheet_url: string;
  worksheet_title: string;
  sync_on: boolean;
  sync_state: 'pending' | 'running' | 'ok' | 'error' | null;
  last_synced_at: string | null;
  sync_finished_at: string | null;
  last_sync_error: string | null;
  sync_items_count: number | null;
}
export const getSalesPlanSheet = (zoneId: string) =>
  axiosInstance.get<{ sheet: SalesPlanSheetDto | null }>(`/ops_tasks/sales-plan/${zoneId}/sheet/`);
export const putSalesPlanSheet = (zoneId: string, sheet_url: string, worksheet_title: string) =>
  axiosInstance.put<{ sheet: SalesPlanSheetDto | null }>(`/ops_tasks/sales-plan/${zoneId}/sheet/`, { sheet_url, worksheet_title });
export const syncSalesPlanSheet = (zoneId: string) =>
  axiosInstance.post<{ sheet: SalesPlanSheetDto | null }>(`/ops_tasks/sales-plan/${zoneId}/sheet/`);
export const deleteSalesPlanSheet = (zoneId: string) =>
  axiosInstance.delete<{ sheet: null }>(`/ops_tasks/sales-plan/${zoneId}/sheet/`);
/** Создать таблицу с шапкой месяца и текущими целями, доступ по ссылке (#3191). */
export const createSalesPlanSheet = (zoneId: string) =>
  axiosInstance.put<{ sheet: SalesPlanSheetDto | null }>(`/ops_tasks/sales-plan/${zoneId}/sheet/`, { create: true });
